import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

type Params = {
  id: string;
  ctgy: string;
};

export function AdminBoardView(routeProps: any) {
  const history = useHistory();
  const { match, location } = routeProps;
  const { id, ctgy } = match.params as Params;
  const [boardItem = [], setBoardItem] = useState<any>();
  const [add, setAdd] = useState(false);
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    if (ctgy === 'qna') {
      setAdd(true);
    }
    server.getBoardItem(ctgy, id).then((payload) => {
      if (!payload) {
        dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
      } else if (payload.code === 260 || payload.code === 500) {
        dispatch(toast.error({ message: '파라미터 오류' }));
      } else {
        setBoardItem(payload);
      }
    });
  }, []);

  const attachFile = (fileList: string[], fileUrl: string[]) => {
    const ret: any = [];

    for (let i = 0; i < fileList.length; i++) {
      if (fileList[i].length !== 0) {
        ret.push(
          <li key={Math.random()}>
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              className="btn-file"
              href={`${process.env.REACT_APP_API_URL}/public${fileUrl[i]}`}
              target="_blank"
            >
              {fileList[i]}
            </a>
          </li>
        );
      }
    }
    return ret;
  };
  const getDeleteButton = () => {
    if (window.confirm('정말 삭제하시겠습니까?')) {
      server.deleteBoard(ctgy, id).then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          routeProps.history.goBack();
        }
      });
    }
  };

  return (
    <main className="sub wrapper board-view">
      <div className="content">
        <div className="title">
          <h1>{ctgy === 'notice' ? '공지사항' : ''}</h1>
          <h1>{ctgy === 'errata' ? '정오표' : ''}</h1>
          <h1>{ctgy === 'lecture-lib' ? '강의 자료실' : ''}</h1>
          <h1>{ctgy === 'lib' ? '일반 자료실' : ''}</h1>
          <h1>{ctgy === 'qna' ? '질의응답' : ''}</h1>
        </div>
        <div className="view-content">
          <div className="view-header">
            <div className="view-title">{boardItem.subject}</div>
            <div className="writer">{boardItem.writer?.name}</div>
            <ul>
              <li className="date">{new Date(boardItem.modDate).toLocaleDateString()}</li>
              <li className="views">{boardItem.hit}</li>
            </ul>
            {boardItem?.attach || (
              <ul className="files">
                <li>
                  <svg
                    className="ico-file"
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 24 24"
                    width="18"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z" />
                  </svg>
                  <span>첨부파일:</span>
                </li>
                {attachFile(
                  [
                    boardItem?.attach1 !== undefined ? boardItem.attach1 : '',
                    boardItem?.attach2 !== undefined ? boardItem.attach2 : '',
                    boardItem?.attach3 !== undefined ? boardItem.attach3 : '',
                    boardItem?.attach4 !== undefined ? boardItem.attach4 : '',
                    boardItem?.attach5 !== undefined ? boardItem.attach5 : '',
                  ],
                  [
                    boardItem?.attach1 !== undefined ? boardItem.attach1Url : '',
                    boardItem?.attach2 !== undefined ? boardItem.attach2Url : '',
                    boardItem?.attach3 !== undefined ? boardItem.attach3Url : '',
                    boardItem?.attach4 !== undefined ? boardItem.attach4Url : '',
                    boardItem?.attach5 !== undefined ? boardItem.attach5Url : '',
                  ]
                )}
              </ul>
            )}
          </div>
          <div className="description">
            <pre>{boardItem.content}</pre>
          </div>
        </div>

        <div className="view-footer">
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.goBack();
            }}
          >
            목록
          </button>
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              getDeleteButton();
            }}
          >
            삭제
          </button>
          <button
            className="btn-sub"
            type="button"
            onClick={() => {
              routeProps.history.push({
                pathname: `/admin/board/adminBoardWrite/${ctgy}/${id}`,
              });
            }}
          >
            수정
          </button>
          {add === true ? (
            <button
              type="button"
              onClick={() => {
                routeProps.history.push({
                  pathname: `/admin/board/adminReplyWrite/${ctgy}/${id}`,
                  state: { replyAdd: add },
                });
              }}
            >
              답글
            </button>
          ) : (
            ''
          )}
        </div>
      </div>
    </main>
  );
}
